module.exports = __webpack_public_path__ + "static/media/UO.8c34b77b.png";